import * as actionTypes from '../../constants/actionTypes';

const defaultState = {
    isLoading: false,
    errorMessage: null,
    activeSport: null,
    results: []
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case actionTypes.ARTICLES_FETCHING:
            return Object.assign({}, state, {
                isLoading: true,
                errorMessage: null
            });

        case actionTypes.ARTICLES_SUCCESS:
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: null,
                results: [...action.results.splice(1, 3)]
            });

        case actionTypes.ARTICLES_FAILED:
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: action.errorMessage
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/articles.js